import { deleteData, getData, postData, putData } from "../Config/AxiosConfig"


export const addInventory = async (body) => {
    return await postData('inventory', body)
}


export const getInventory = async (
    id,
    page = 1,
    limit = 10,
    startDate = "",
    endDate = ""
) => {
    let url = `inventory/${id}?page=${page}&limit=${limit}`;

    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    return await getData(url);
};